// src/hooks/usePurchases.js
import { useState, useEffect, useCallback } from 'react';
import { purchasesApi } from '../services/api';

/**
 * Compras cargadas a mano para el Libro de Compras.
 *
 * Las operaciones devuelven el error para que la pantalla lo muestre en el
 * formulario: los mensajes del servidor son los útiles acá («ya cargaste esa
 * factura», «los montos no cuadran»), y tragárselos dejaría al usuario sin
 * saber qué corregir.
 */
export const usePurchases = (filtrosIniciales = {}) => {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filtros, setFiltros] = useState(filtrosIniciales);

  const fetchPurchases = useCallback(async (filtrosNuevos) => {
    try {
      setError(null);
      setLoading(true);
      const data = await purchasesApi.getAll(filtrosNuevos ?? filtros);
      setPurchases(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e.message || 'No se pudieron cargar las compras.');
    } finally {
      setLoading(false);
    }
  }, [filtros]);

  useEffect(() => { fetchPurchases(); }, [fetchPurchases]);

  const savePurchase = async (compra) => {
    const guardada = compra._id
      ? await purchasesApi.update(compra._id, compra)
      : await purchasesApi.create(compra);
    await fetchPurchases();
    return guardada;
  };

  const deletePurchase = async (id) => {
    await purchasesApi.delete(id);
    await fetchPurchases();
  };

  return {
    purchases, loading, error,
    filtros, setFiltros,
    fetchPurchases, savePurchase, deletePurchase
  };
};

export default usePurchases;
